/**
 * Helpers for handling promises.
 */
export class Promises {

  /**
   * Runs promises in sequence (not paralles as in Promise.all)
   * @param promiseTasks Tasks creating promises to resolve in sequence.
   * @returns Result array of promises.
   */
  public static async sequence<T>(promiseTasks: Array<() => Promise<T>>): Promise<T[]> {
    const result: any[] = [];

    for (const promiseTask of promiseTasks) {
      result.push(await promiseTask());
    }

    return result;
  }
}